module.exports = "<md-dialog class=md-dialog--m> <md-dialog-content class=md-dialog-content> <h2 class=md-dialog-title>Folders</h2> <dt-folder-selector pre-selected=$ctrl.preSelected on-change=$ctrl.onFolderChange($event)></dt-folder-selector> </md-dialog-content> <md-dialog-actions class=\"space-p-b-m space-p-r-m\"> <md-button class=md-primary ng-click=$ctrl.close()> Cancel </md-button> <md-button class=md-primary ng-click=$ctrl.submit() ng-disabled=!$ctrl.folderId> Assign sensor to this folder </md-button> </md-dialog-actions> </md-dialog> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/folder-path-edit/dialog/dialog.html
// module id = TpVu
// module chunks = 1